<mat-form-field appearance="fill" *ngIf="control" hideRequiredMarker>
    <mat-label>{{ placeholder }}
        <ng-container *ngIf="required"> *</ng-container>
    </mat-label>
    <input matInput
           [formControl]="control"
           [id]="id"
           [autocomplete]="autocomplete"
           [type]="showPasswordText ? 'text' : 'password'"
    />
    <span matSuffix (click)="showPasswordText = !showPasswordText"
          class="icon icon-{{ showPasswordText ? 'eye-crossed' : 'eye' }}"></span>
    <mat-hint align="start" *ngIf="passwordStrength">
        <mat-password-strength [password]="control.value"></mat-password-strength>
    </mat-hint>
    <mat-error *ngIf="control.hasError('required')">
        {{ 'ERRORS.FIELD_IS_REQUIRED' | translate }}
    </mat-error>
    <mat-error *ngIf="!control.hasError('required') && control.hasError('minlength')">
        {{ 'ERRORS.MINLENGTH_EXCEEDS_WITH' | translate }} {{ control.getError('minlength').requiredLength }}
    </mat-error>
    <mat-error
            *ngIf="!control.hasError('required') && !control.hasError('minlength') && control.hasError('maxlength')">
        {{ 'ERRORS.MAXLENGTH_EXCEEDS_WITH' | translate }} {{ control.getError('maxlength').requiredLength }}
    </mat-error>
    <mat-error>
        <ng-content></ng-content>
    </mat-error>
</mat-form-field>
